import { render, staticRenderFns } from "./RecentFiled.vue?vue&type=template&id=61ee226c"
import script from "./RecentFiled.vue?vue&type=script&lang=js"
export * from "./RecentFiled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports